$( document ).ready(function() {
    $('.secondscreen').show();
    $('.sec1').show().css('display', 'block'); 
    // $('.modalss').hide();
  });

// onload=(function(){

$(document).ready(function() {
    $('.my-product').click(function() {
        $('.my-product.sec-box-shadow');
        $(this).toggleClass("sec-box-shadow");
        var Attributesimages = $('.sec-box-shadow').map(function() {
             return $(this).find('.my-image').prop('src'); 
        }).get();
        $(".final-bundle-item").empty();
        $.each(Attributesimages, function(index){
          $(".final-bundle-item").append("<img src=\"" + Attributesimages[index] + "\">");
        });
        console.log('for full image url ' + Attributesimages );

        Shopify.queue = [];
        var AllProducts = $('.sec-box-shadow').map(function() {
           return Shopify.queue.push({
              id: $(this).data('id'),
              quantity: 1
            });
        }).get();
        console.log(Shopify.queue);
        var allAttributes = $('.sec-box-shadow').map(function() {
          return $(this).data('id');
        }).get();
        console.log(allAttributes);
        var AttributesPrices = $('.sec-box-shadow').map(function() {
          return $(this).data('price').replace(/[^0-9]/g,'');         
        }).get();
        console.log(allAttributes.length);
                 var total = 0;
        $.each(AttributesPrices,function() {
            total += parseInt(this, 10);
        });
        console.log(total);
      var discount;
      if (allAttributes.length < 2){
        discount = 0;
       discount = total;
       $(".total-discount-percent").html("SAVE UP TO 0%");
       $(".original-price").html(total);
        $(".subtotal-price").html(discount);
        $(".proceed-checkout").hide();
        console.log(discount);
      }

      else if (allAttributes.length === 2){
       discount = 0;
       discount = total - (total * 0.05);
       $(".total-discount-percent").html("SAVE UP TO 5%");
       $(".bnd-txt").html("MYOB5")
       $(".modal-popupss-new").html("Use this code at check out and avail 5% discount on your bundle!")
       $(".original-price").html(total);
       $(".subtotal-price").html(discount);
       $(".proceed-checkout").show();

        console.log(discount);
      }
      else if (allAttributes.length === 3){
        discount = 0;
       discount = total - (total * 0.10);
       $(".total-discount-percent").html("SAVE UP TO 10%");
       $(".bnd-txt").html("MYOB10")
       $(".modal-popupss-new").html("Use this code at check out and avail 10% discount on your bundle!")
       $(".original-price").html(total);
       $(".subtotal-price").html(discount);
       $(".proceed-checkout").show();

        console.log(discount);
      }
      else if (allAttributes.length === 4){
        discount = 0;
       discount = total - (total * 0.15);
       $(".total-discount-percent").html("SAVE UP TO 15%");
       $(".bnd-txt").html("MYOB15")
      $(".modal-popupss-new").html("Use this code at check out and avail 15% discount on your bundle!") 
       $(".original-price").html(total);
       $(".subtotal-price").html(discount);
       $(".proceed-checkout").show();

        console.log(discount);
      }
      else if (allAttributes.length === 5){
        discount = 0;
       discount = total - (total * 0.20);
       $(".total-discount-percent").html("SAVE UP TO 20%");
       $(".bnd-txt").html("MYOB20")
      $(".modal-popupss-new").html("Use this code at check out and avail 20% discount on your bundle!") 
       $(".original-price").html(total);
       $(".subtotal-price").html(discount);
       $(".proceed-checkout").show();
        console.log(discount);
      }
      else {
        discount = total - (total * 0.20);
        $(".original-price").html(total);
       $(".subtotal-price").html(discount);
       $(".proceed-checkout").show();
        console.log(discount);
      }

    });
      // $('.proceed-checkout').click(function() {
      // $('.modalss').show();
      //   });

    $('.pre-step').click(function() {
          Shopify.queue = [];
          var AllProducts = $('.sec-box-shadow').map(function() {
             return Shopify.queue.push({
                id: $(this).data('id'),
                quantity: 1
              });
          }).get();
          console.log(Shopify.queue);
          $.post('/cart/add.js', {
            items: Shopify.queue
          })
          .done(function() {
            console.log( "success" );
            window.location.href = 'https://iqorganicsolution.pk/checkout';
          })
          .fail(function() {
            console.log( "error" );
          })
        });

        $(".proceed-checkout").hide();
        var modal = document.getElementById("myModalss");
        var span = document.getElementsByClassName("closess")[0];
        span.onclick = function() {
         modal.style.display = "none";
        }
        window.onclick = function(event) {
         if (event.target == modal) {
         modal.style.display = "none";
         }                                  
        }
        // $(document).on('click', '#copyCodeBtn', function() {
        //   const code = $('#discountCode').text().trim();

        //   navigator.clipboard.writeText(code).then(() => {
        //     $('#copyMsg').fadeIn();

        //     setTimeout(() => {
        //       $('#copyMsg').fadeOut();
        //     }, 1000);
        //   });
        // });
});